import { formatRangeLabel } from "../../utils/dateRange";

/**
 * Shows the applied / selected date range next to filter controls.
 */
const DateRangeAppliedLabel = ({
  from = "",
  to = "",
  prefix = "Date range: ",
  emptyLabel = "All dates",
  className = "",
}) => (
  <span className={`inline-flex md:h-11 items-center text-sm leading-none text-gray-600 ${className}`}>
    {prefix ? <span>{prefix}</span> : null}
    <span className="font-UbuntuMedium text-gray-800">
      {formatRangeLabel(from, to, { emptyLabel })}
    </span>
  </span>
);

export default DateRangeAppliedLabel;
